export const READER_REQUEST_BOX_READ_MODES = {
  mastercases: 0,
  boxes: 1
};
